import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
// import axios from "axios";
// import { serverApi } from "../../../../config/Keys";
// import Alert from "react-s-alert";
// import Image from "react-bootstrap/Image";
import classnames from "classnames";
import Form from "react-bootstrap/Form";
import {
  PopupActionButton,
  IconButtonReusableComponent,
} from "../../buttonReusableComponent/ButtonReusableComponent";
import {
  InputBoxComponent,
  TextAreaReusableComponent,
} from "../../inputReusableComponent/InputBoxComponent";
import Switch from "react-switch";

// import axios from "axios";
// import { serverApi } from "../../../../config/Keys";
import SingleImageReusableComponent from "../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { OffersValidation } from "../../../../store/validation/allValidationFile/offersDashboardValidation/OffersValidation";
import { vendor_create_new_events } from "../../../../store/actions/vendorOffersAndEventsAction";

export class EventPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      open: false,
      name: "",
      description: "",
      startDate: "",
      endDate: "",
      couponCode: "",
      address: "",
      addEvent: "",
      termsConditions: "",
      eventPrimary: false,
      activeEvent: true,
      errors: {},
    };
    // this.onSingleImageDrop = this.onSingleImageDrop.bind(this);
    this.eventPrimary = this.eventPrimary.bind(this);
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  eventPrimary(eventPrimary) {
    this.setState({
      eventPrimary,
      actionButton: true,
    });
  }

  onOpenModal = () => {
    this.setState({ open: true });
    this.props.clear_all_errors();
  };

  onCloseModal = () => {
    this.setState({
      actionButton: false,
      open: false,
      name: "",
      description: "",
      startDate: "",
      endDate: "",
      couponCode: "",
      address: "",
      addEvent: "",
      termsConditions: "",
      eventPrimary: false,
      errors: {},
    });
    this.props.clear_all_errors();
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    // this.setState({
    //   [e.target.name]: e.target.value,
    // });
    this.props.clear_all_errors();
    if (
      e.target.name === "description" ||
      e.target.name === "termsConditions"
    ) {
      let caps = e.target.value;
      caps = caps.charAt(0).toUpperCase() + caps.slice(1);
      let dataSet = caps;
      this.setState({
        [e.target.name]: dataSet,
        actionButton: true,
      });
    } else {
      let data = e.target.value.split(" ");
      let newarray1 = [];
      for (let x = 0; x < data.length; x++) {
        newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
      }
      let newData = newarray1.join(" ");
      this.setState({
        [e.target.name]: newData,
        actionButton: true,
      });
    }
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  // /**************************************
  //  * @DESC - ON IMAGE UPLOAD HANDLER
  //  * @DESC - USER DEFINED METHODS
  //  **************************************/
  // onSingleImageDrop(picture) {
  //   this.setState({
  //     addEvent: picture,
  //   });
  // }

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/

  onCompleteCrop = (url) => {
    this.setState({
      addEvent: url,
      logo_main: null,
      singleImageLoader: false,
      actionButton: true,
    });
  };

  onCancelCrop = () => {
    this.setState({ logo_main: null });
  };

  onImageLogoUploadHandler = (e) => {
    // this.setState({ loader: true });
    const vendor_id = this.props.auth.user.VendorUser._id;
    const restaurant_name = this.props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    data.append("files", e.target.files[0]);
    this.setState({
      logo_main: e.target.files[0],
      combined: combined,
    });
    // axios
    //   .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
    //     headers: {
    //       "content-type": "multipart/form-data",
    //     },
    //   })
    //   .then((res) => {
    //     this.setState({ addEvent: res.data, loader: false });
    //     Alert.success(`<h4>Event Image Upload Successfully</h4>`, {
    //       position: "top-right",
    //       effect: "bouncyflip",
    //       beep: true,
    //       html: true,
    //       timeout: 3000,
    //       offset: 35,
    //     });
    //   })
    //   .catch((err) => {
    //     this.setState({ loader: false });
    //     Alert.error(`<h4>Error while uploading the image</h4>`, {
    //       position: "top-right",
    //       effect: "bouncyflip",
    //       beep: true,
    //       html: true,
    //       timeout: 3000,
    //       offset: 35,
    //     });
    //   });
  };

  removeFile = (e) => {
    let removeEventImage = this.state.addEvent;
    removeEventImage = "";
    this.setState({
      addEvent: removeEventImage,
      actionButton: true,
    });
  };

  // onImageLogoUploadHandler = (e) => {
  //   this.setState({ loader: true });
  //   const data = new FormData();
  //   data.append("image", e.target.files[0]);
  //   axios
  //     .post(`${serverApi}/image/upload-content-images`, data)
  //     .then((res) => {
  //       this.setState({ addEvent: res.data.image_URL, loader: false });
  //     })
  //     .catch((err) => {
  //       this.setState({ loader: false });
  //       window.alert("Error while uploading the image");
  //     });
  // };

  onOfferSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = OffersValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      if (this.props.auth.user.VendorUser._id) {
        const token = this.props.auth.user.accessToken;
        const formData = {
          vendor_id: this.props.auth.user.VendorUser._id,
          name: this.state.name,
          description: this.state.description,
          mark_as_primary: this.state.eventPrimary,
          start_date: Date.parse(this.state.startDate),
          end_date: Date.parse(this.state.endDate),
          coupon_code: this.state.couponCode,
          venue_address: this.state.address,
          photos: this.state.addEvent,
          terms_and_condition: this.state.termsConditions,
          active: this.state.activeEvent,
          send_to_carousel: false,
        };
        this.props.vendor_create_new_events(formData, token);
        this.setState({
          open: false,
          name: "",
          description: "",
          startDate: "",
          endDate: "",
          couponCode: "",
          address: "",
          addEvent: "",
          termsConditions: "",
          eventPrimary: false,
        });
      }
    }
  };

  render() {
    const {
      open,
      errors,
      name,
      description,
      startDate,
      endDate,
      couponCode,
      address,
      termsConditions,
    } = this.state;
    return (
      <div>
        <IconButtonReusableComponent
          buttonText="Add Event"
          onClick={this.onOpenModal}
          buttonType="button"
        />
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "offer-event-main",
            // closeButton: "customCloseButtonCalling",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="offer-view-topbar">
            <h4>{this.props.bigText}</h4>
          </div>
          <div className="offer-event-popup-peding">
            <Form noValidate onSubmit={this.onOfferSubmit}>
              <InputBoxComponent
                displayLabel={true}
                controlId="name"
                labelText="Name"
                inputType="text"
                placeHolder="eg. Buy 1 Get 1 Free"
                name="name"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                value={this.state.name}
                required="required"
                showBottom={true}
                error={
                  errors.name === "name is required"
                    ? "event name is required"
                    : null
                }
                inputClassName={classnames("input-component-inputfield", {
                  invalid: errors.name,
                })}
              />
              <TextAreaReusableComponent
                controlId="descriptionTextArea"
                displayText={true}
                labelText="Description"
                labelSmall="(Fill out the details , offers are used offline)"
                labelTextClass="col-12 text-area-lable p-0"
                placeholder="eg. A bright Atmosphere"
                rows="4"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                name="description"
                value={this.state.description}
                inputClassName={classnames("input-text-area text-area-new", {
                  invalid: errors.description,
                })}
                error={errors.description}
              />
              {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 d-flex align-items-center"> */}
              <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center">
                  <div className="">
                    <Switch
                      checked={this.state.eventPrimary}
                      onChange={this.eventPrimary}
                      width={40}
                      height={20}
                      onColor="#59F832"
                      onHandleColor="#ffffff"
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      // className="react-switch"
                      id="material-switch"
                    />
                  </div>
                  <div className="pl-2">
                    <Form.Label className="text-area-lable">
                      Make This Events Primary
                    </Form.Label>
                    <p className="text-area-lable-make-primary">
                      (Note you can make only one event primary, by making This
                      event primary it will remove primary from other active
                      events)
                    </p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <InputBoxComponent
                    displayLabel={true}
                    showLabelSmall={true}
                    controlId="couponCode"
                    labelText={
                      <div className="d-flex align-items-center">
                        Coupon Code&nbsp;<p> ( 10 Char )</p>
                      </div>
                    }
                    inputType="text"
                    placeHolder="eg. c-137"
                    name="couponCode"
                    onChange={this.onChange}
                    onFocusOut={this.onFocusOut}
                    value={this.state.couponCode}
                    required="required"
                    showBottom={true}
                    error={
                      errors.couponCode === "couponCode is required"
                        ? "coupon code is required"
                        : null
                    }
                    inputClassName={classnames("input-component-inputfield", {
                      invalid: errors.couponCode,
                    })}
                  />
                </div>
                {/* </div> */}
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <InputBoxComponent
                    displayLabel={true}
                    controlId="startDate"
                    labelText="Start Date"
                    inputType="datetime-local"
                    placeHolder="Enter Start Date"
                    name="startDate"
                    onChange={this.onChange}
                    onFocusOut={this.onFocusOut}
                    value={this.state.startDate}
                    required="required"
                    showBottom={true}
                    error={
                      errors.startDate === "startDate is required"
                        ? "start date is required"
                        : null
                    }
                    inputClassName={classnames("input-component-inputfield", {
                      invalid: errors.startDate,
                    })}
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <InputBoxComponent
                    displayLabel={true}
                    controlId="endDate"
                    labelText="End Date"
                    inputType="datetime-local"
                    placeHolder="Enter End Date"
                    name="endDate"
                    onChange={this.onChange}
                    onFocusOut={this.onFocusOut}
                    value={this.state.endDate}
                    required="required"
                    showBottom={true}
                    error={
                      errors.endDate === "endDate is required"
                        ? "end date is required"
                        : null
                    }
                    inputClassName={classnames("input-component-inputfield", {
                      invalid: errors.endDate,
                    })}
                  />
                </div>
              </div>
              <TextAreaReusableComponent
                controlId="address"
                displayText={true}
                labelText="Venue / Address"
                labelTextClass="col-12 text-area-lable p-0"
                placeholder="84/36, N Main Rd, Koregaon Park Annexe, Mundhwa, Pune, Maharashtra 411001"
                rows="5"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                name="address"
                value={this.state.address}
                inputClassName={classnames("input-text-area text-area-new", {
                  invalid: errors.address,
                })}
                error={errors.address}
              />
              <SingleImageReusableComponent
                title="Add Photo*"
                smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
                // onDrop={this.onSingleImageDrop}
                onChange={this.onImageLogoUploadHandler}
                combined={this.state.combined && this.state.combined}
                onCompleteCrop={this.onCompleteCrop}
                onCancelCrop={this.onCancelCrop}
                file={
                  (this.state.logo_main &&
                    this.state.logo_main !== null &&
                    this.state.logo_main) ||
                  (this.state.addEvent && this.state.addEvent)
                }
                resetFile={this.removeFile}
                name="addEvent"
                error={errors.addEvent}
              />
              {/* <div className="file_upload mt-3">
                <div className="file-lable-text">
                  <label>Add Event</label>
                  <p>
                    ( You can upload only 1 pic per offer 700 x 420 pixels )
                  </p>
                </div>
                <div className="view_chainsBor mt-0" style={{ width: "100%" }}>
                  <div className="custom_file_upload">
                    <input
                      type="file"
                      name="icon"
                      id="file"
                      onChange={this.onImageLogoUploadHandler}
                      className="custom_input_upload"
                    />
                    <label
                      className="custom_input_label newChain_add"
                      htmlFor="file"
                    >
                      <div>
                        <i
                          className="fa fa-plus"
                          style={{ color: "#CCCCCC" }}
                        ></i>
                      </div>
                      <div className="add_new_text"></div>
                    </label>
                  </div>

                  <div className="newChain_addthree mx-3">
                    {this.state.addEvent ? (
                      <img
                        src={this.state.addEvent}
                        className="newChain_addtwo"
                        style={{ height: "100%", width: "100%" }}
                        alt="chain"
                      />
                    ) : null}
                  </div>
                </div>
                <Form.Text className="text-muted input-component-bottom">
                  <div className="text-danger text-capitalize">
                    {errors.addOffer}
                  </div>
                </Form.Text>
              </div> */}
              <div className="offer-event-mobile-floatingtext">
                <TextAreaReusableComponent
                  controlId="termsConditions"
                  displayText={true}
                  labelText="Terms & Conditions"
                  labelSmall="(Fill out the terms and conditions for offers are used offline)"
                  labelTextClass="col-12 text-area-lable p-0"
                  placeholder="eg. Offers are valid during week days and cannot be combined with any other offer Payment offers are some times offered in combination with other payment partners"
                  rows="4"
                  onChange={this.onChange}
                  onFocusOut={this.onFocusOut}
                  name="termsConditions"
                  value={this.state.termsConditions}
                  inputClassName={classnames("input-text-area text-area-new", {
                    invalid: errors.termsConditions,
                  })}
                  error={
                    errors.termsConditions === "termsConditions is required"
                      ? "terms conditions is required"
                      : null
                  }
                />
              </div>
              <div className="offer-event-mobile-button-float">
                <div className="bottom-button d-flex justify-content-between mt-3 offer-event-inside-button">
                  <PopupActionButton
                    buttonText="Cancel"
                    buttonType="button"
                    buttonClass="bigbuttonred"
                    onClick={this.onCloseModal}
                  />
                  <div className="offer-event-inside-button-margin">
                    <PopupActionButton
                      buttonText="Save"
                      buttonType={
                        name === "" ||
                        description === "" ||
                        startDate === "" ||
                        endDate === "" ||
                        couponCode === "" ||
                        address === "" ||
                        termsConditions === ""
                          ? "button"
                          : "Submit"
                      }
                      buttonClass={
                        name === "" ||
                        description === "" ||
                        startDate === "" ||
                        endDate === "" ||
                        couponCode === "" ||
                        address === "" ||
                        termsConditions === ""
                          ? "bigbuttongray"
                          : "bigbuttongreen"
                      }
                      disabled={
                        name === "" ||
                        description === "" ||
                        startDate === "" ||
                        endDate === "" ||
                        couponCode === "" ||
                        address === "" ||
                        termsConditions === ""
                          ? true
                          : false
                      }
                    />
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

EventPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_create_new_events,
})(withRouter(EventPopup));

// import React, { useState } from "react";
// import { Button, Image } from "react-bootstrap";
// import "react-responsive-modal/styles.css";
// import { Modal } from "react-responsive-modal";
// import OfflineEvent from "../../../vendorDashboardComponents/events/AddNewEventVendor/OfflineEvent";
// import OnlineEvent from "../../../vendorDashboardComponents/events/AddNewEventVendor/OnlineEvent";
// const EventPopup = () => {
//   //state
//   const [state, setState] = useState({
//     open: false,
//   });
//   const [selectedTab, setSelectedTab] = useState(1);
//   const handleTab = (e) => {
//     setSelectedTab(e);
//   };
//   const onOpenModal = () => {
//     setState({
//       open: true,
//     });
//   };
//   const onCloseModal = () => {
//     setState({
//       open: false,
//     });
//   };
//   return (
//     <React.Fragment>
//       <button
//         type="button"
//         className="btn btn-danger text-normal btn-xs rounded"
//         onClick={onOpenModal}
//       >
//         + Add Event
//       </button>
//       <Modal
//         open={state.open}
//         onClose={onCloseModal}
//         center
//         classNames={{
//           overlay: "customOverlay-request-accept-cancelled",
//           modal: "offer-event-main closeRemove min-height-100vh w-100",
//           animationIn: "customEnterAnimation",
//           animationOut: "customLeaveAnimation",
//         }}
//         animationDuration={1000}
//       >
//         <div className="d-flex align-items-center py-3 px-4 border-bottom">
//           <span className="pr-3 cursor" onClick={onCloseModal}>
//             <Image
//               alt="Back"
//               width="20px"
//               src={require("../../../../assets/images/UserManagement/backIcon.svg")}
//             />
//           </span>
//           <div className="f12-400 c_black">Add New Event</div>
//         </div>
//         <div className="d-flex align-items-start p-3">
//           <Button
//             variant="link"
//             className={`enAddOffersOPtion ${selectedTab === 1 ? "active" : ""}`}
//             onClick={(e) => handleTab(1)}
//           >
//             <Image
//               src={
//                 selectedTab === 1
//                   ? require("../../../../assets/images/Menu/vandorGridMenu/2-red.svg")
//                   : require("../../../../assets/images/Menu/vandorGridMenu/2.svg")
//               }
//               alt="Offline Offers"
//               title="Offline Offers"
//               width="40px"
//               height="40px"
//               className="ml-3"
//             />
//             <span className="active f12-400 pt-2 d-block w-100 mb-2">
//               Offline Event
//             </span>
//             <span className="w-100 f9-400 d-block">
//               (Note: Events are in a physical venue and you can even accept
//               RSVP)
//             </span>
//           </Button>
//           <Button
//             variant="link"
//             className={`enAddOffersOPtion ml-3 ${
//               selectedTab === 2 ? "active" : ""
//             }`}
//             onClick={(e) => handleTab(2)}
//           >
//             <Image
//               src={
//                 selectedTab === 2
//                   ? require("../../../../assets/images/Menu/vandorGridMenu/2-red.svg")
//                   : require("../../../../assets/images/Menu/vandorGridMenu/2.svg")
//               }
//               alt="Online Offers"
//               title="Online Offers"
//               width="40px"
//               height="40px"
//               className="ml-3"
//             />
//             <span className="active f12-400 pt-2 d-block w-100 mb-2">
//               Online Event
//             </span>
//             <span className="w-100 f9-400 d-block">
//               (Note: Events are online you need a link stored at the time Event
//               creation You can accept RSVP for the event)
//             </span>
//           </Button>
//         </div>
//         <div className="px-3">
//           {selectedTab === 1 && <OfflineEvent onCloseModal={onCloseModal} />}
//           {selectedTab === 2 && <OnlineEvent onCloseModal={onCloseModal} />}
//         </div>
//       </Modal>
//     </React.Fragment>
//   );
// };
// export default EventPopup;

// // import React, { Component } from "react";
// // import "react-responsive-modal/styles.css";
// // import { Modal } from "react-responsive-modal";
// // import axios from "axios";
// // import { serverApi } from "../../../../config/Keys";
// // import Alert from "react-s-alert";
// // // import Image from "react-bootstrap/Image";
// // import classnames from "classnames";
// // import Form from "react-bootstrap/Form";
// // import {
// //   PopupActionButton,
// //   IconButtonReusableComponent,
// // } from "../../buttonReusableComponent/ButtonReusableComponent";
// // import {
// //   InputBoxComponent,
// //   TextAreaReusableComponent,
// // } from "../../inputReusableComponent/InputBoxComponent";
// // import Switch from "react-switch";

// // // import axios from "axios";
// // // import { serverApi } from "../../../../config/Keys";
// // import SingleImageReusableComponent from "../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";

// // import PropTypes from "prop-types";
// // import { connect } from "react-redux";
// // import { withRouter } from "react-router-dom";
// // import { clear_all_errors } from "../../../../store/actions/errorActions";
// // import { OffersValidation } from "../../../../store/validation/allValidationFile/offersDashboardValidation/OffersValidation";
// // import { vendor_create_new_events } from "../../../../store/actions/vendorOffersAndEventsAction";

// // export class EventPopup extends Component {
// //   constructor(props) {
// //     super(props);
// //     this.state = {
// //       actionButton: false,
// //       open: false,
// //       name: "",
// //       description: "",
// //       startDate: "",
// //       endDate: "",
// //       couponCode: "",
// //       address: "",
// //       addEvent: "",
// //       termsConditions: "",
// //       eventPrimary: false,
// //       activeEvent: true,
// //       errors: {},
// //     };
// //     // this.onSingleImageDrop = this.onSingleImageDrop.bind(this);
// //     this.eventPrimary = this.eventPrimary.bind(this);
// //   }

// //   static getDerivedStateFromProps(nextProps, nextState) {
// //     if (
// //       Object.keys(nextProps.errors).length > 0 &&
// //       nextProps.errors !== nextState.errors
// //     ) {
// //       return {
// //         errors: nextProps.errors,
// //       };
// //     }
// //     return null;
// //   }

// //   /**************************
// //    * @DESC - Current and Saving HANDLER
// //    ***************************/
// //   eventPrimary(eventPrimary) {
// //     this.setState({
// //       eventPrimary,
// //       actionButton: true,
// //     });
// //   }

// //   onOpenModal = () => {
// //     this.setState({ open: true });
// //     this.props.clear_all_errors();
// //   };

// //   onCloseModal = () => {
// //     this.setState({
// //       actionButton: false,
// //       open: false,
// //       name: "",
// //       description: "",
// //       startDate: "",
// //       endDate: "",
// //       couponCode: "",
// //       address: "",
// //       addEvent: "",
// //       termsConditions: "",
// //       eventPrimary: false,
// //       errors: {},
// //     });
// //     this.props.clear_all_errors();
// //   };

// //   /**************************
// //    * @DESC - ONCHANGE HANDLER
// //    ***************************/
// //   onChange = (e) => {
// //     // this.setState({
// //     //   [e.target.name]: e.target.value,
// //     // });
// //     this.props.clear_all_errors();
// //     if (
// //       e.target.name === "description" ||
// //       e.target.name === "termsConditions"
// //     ) {
// //       let caps = e.target.value;
// //       caps = caps.charAt(0).toUpperCase() + caps.slice(1);
// //       let dataSet = caps;
// //       this.setState({
// //         [e.target.name]: dataSet,
// //         actionButton: true,
// //       });
// //     } else {
// //       let data = e.target.value.split(" ");
// //       let newarray1 = [];
// //       for (let x = 0; x < data.length; x++) {
// //         newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
// //       }
// //       let newData = newarray1.join(" ");
// //       this.setState({
// //         [e.target.name]: newData,
// //         actionButton: true,
// //       });
// //     }
// //   };

// //   onFocusOut = (e) => {
// //     const { errors } = this.state;
// //     if (e.target.value === "") {
// //       errors[e.target.name] = `${e.target.name} is required`;
// //     } else {
// //       errors[e.target.name] = "";
// //     }
// //     this.setState({
// //       errors: errors,
// //     });
// //   };

// <<<<<<< HEAD
// //   // /**************************************
// //   //  * @DESC - ON IMAGE UPLOAD HANDLER
// //   //  * @DESC - USER DEFINED METHODS
// //   //  **************************************/
// //   // onSingleImageDrop(picture) {
// //   //   this.setState({
// //   //     addEvent: picture,
// //   //   });
// //   // }
// =======
//   /**************************************
//    * @DESC - ON IMAGE UPLOAD HANDLER
//    * @DESC - USER DEFINED METHODS
//    **************************************/

//   onCompleteCrop = (url) => {
//     this.setState({
//       addEvent: url,
//       logo_main: null,
//       singleImageLoader: false,
//       actionButton: true,
//     });
//   };

//   onCancelCrop = () => {
//     this.setState({ logo_main: null });
//   };

//   onImageLogoUploadHandler = (e) => {
//     // this.setState({ loader: true });
//     const vendor_id = this.props.auth.user.VendorUser._id;
//     const restaurant_name = this.props.onboarding.restaurant_name
//       .split(" ")
//       .join("");
//     const combined = vendor_id + "_" + restaurant_name;
//     const data = new FormData();
//     data.append("files", e.target.files[0]);
//     this.setState({
//       logo_main: e.target.files[0],
//       combined: combined,
//     });
//     // axios
//     //   .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
//     //     headers: {
//     //       "content-type": "multipart/form-data",
//     //     },
//     //   })
//     //   .then((res) => {
//     //     this.setState({ addEvent: res.data, loader: false });
//     //     Alert.success(`<h4>Event Image Upload Successfully</h4>`, {
//     //       position: "top-right",
//     //       effect: "bouncyflip",
//     //       beep: true,
//     //       html: true,
//     //       timeout: 3000,
//     //       offset: 35,
//     //     });
//     //   })
//     //   .catch((err) => {
//     //     this.setState({ loader: false });
//     //     Alert.error(`<h4>Error while uploading the image</h4>`, {
//     //       position: "top-right",
//     //       effect: "bouncyflip",
//     //       beep: true,
//     //       html: true,
//     //       timeout: 3000,
//     //       offset: 35,
//     //     });
//     //   });
//   };
// >>>>>>> 4433f9782c23e400f1cef29dbefdd83def56e9d7

// //   /**************************************
// //    * @DESC - ON IMAGE UPLOAD HANDLER
// //    * @DESC - USER DEFINED METHODS
// //    **************************************/
// //   onImageLogoUploadHandler = (e) => {
// //     // this.setState({ loader: true });
// //     const vendor_id = this.props.auth.user.VendorUser._id;
// //     const restaurant_name = this.props.onboarding.restaurant_name
// //       .split(" ")
// //       .join("");
// //     const combined = vendor_id + "_" + restaurant_name;
// //     const data = new FormData();
// //     data.append("files", e.target.files[0]);
// //     axios
// //       .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
// //         headers: {
// //           "content-type": "multipart/form-data",
// //         },
// //       })
// //       .then((res) => {
// //         this.setState({ addEvent: res.data, loader: false });
// //         Alert.success(`<h4>Event Image Upload Successfully</h4>`, {
// //           position: "top-right",
// //           effect: "bouncyflip",
// //           beep: true,
// //           html: true,
// //           timeout: 3000,
// //           offset: 35,
// //         });
// //       })
// //       .catch((err) => {
// //         this.setState({ loader: false });
// //         Alert.error(`<h4>Error while uploading the image</h4>`, {
// //           position: "top-right",
// //           effect: "bouncyflip",
// //           beep: true,
// //           html: true,
// //           timeout: 3000,
// //           offset: 35,
// //         });
// //       });
// //   };

// //   removeFile = (e) => {
// //     let removeEventImage = this.state.addEvent;
// //     removeEventImage = "";
// //     this.setState({
// //       addEvent: removeEventImage,
// //       actionButton: true,
// //     });
// //   };

// //   // onImageLogoUploadHandler = (e) => {
// //   //   this.setState({ loader: true });
// //   //   const data = new FormData();
// //   //   data.append("image", e.target.files[0]);
// //   //   axios
// //   //     .post(`${serverApi}/image/upload-content-images`, data)
// //   //     .then((res) => {
// //   //       this.setState({ addEvent: res.data.image_URL, loader: false });
// //   //     })
// //   //     .catch((err) => {
// //   //       this.setState({ loader: false });
// //   //       window.alert("Error while uploading the image");
// //   //     });
// //   // };

// <<<<<<< HEAD
// //   onOfferSubmit = (e) => {
// //     e.preventDefault();
// //     const { errors, isValid } = OffersValidation(this.state);
// //     if (!isValid) {
// //       this.setState({
// //         errors: errors,
// //       });
// //     } else {
// //       if (this.props.auth.user.VendorUser._id) {
// //         const token = this.props.auth.user.accessToken;
// //         const formData = {
// //           vendor_id: this.props.auth.user.VendorUser._id,
// //           name: this.state.name,
// //           description: this.state.description,
// //           mark_as_primary: this.state.eventPrimary,
// //           start_date: Date.parse(this.state.startDate),
// //           end_date: Date.parse(this.state.endDate),
// //           coupon_code: this.state.couponCode,
// //           venue_address: this.state.address,
// //           photos: this.state.addEvent,
// //           terms_and_condition: this.state.termsConditions,
// //           active: this.state.activeEvent,
// //           send_to_carousel: false,
// //         };
// //         this.props.vendor_create_new_events(formData, token);
// //         this.setState({
// //           open: false,
// //           name: "",
// //           description: "",
// //           startDate: "",
// //           endDate: "",
// //           couponCode: "",
// //           address: "",
// //           addEvent: "",
// //           termsConditions: "",
// //           eventPrimary: false,
// //         });
// //       }
// //     }
// //   };
// =======
//   render() {
//     const {
//       open,
//       errors,
//       name,
//       description,
//       startDate,
//       endDate,
//       couponCode,
//       address,
//       termsConditions,
//     } = this.state;
//     return (
//       <div>
//         <IconButtonReusableComponent
//           buttonText="Add Event"
//           onClick={this.onOpenModal}
//           buttonType="button"
//         />
//         <Modal
//           open={open}
//           onClose={this.onCloseModal}
//           center
//           classNames={{
//             overlay: "customOverlay-request-accept-cancelled",
//             modal: "offer-event-main",
//             // closeButton: "customCloseButtonCalling",
//             animationIn: "customEnterAnimation",
//             animationOut: "customLeaveAnimation",
//           }}
//           animationDuration={1000}
//         >
//           <div className="offer-view-topbar">
//             <h4>{this.props.bigText}</h4>
//           </div>
//           <div className="offer-event-popup-peding">
//             <Form noValidate onSubmit={this.onOfferSubmit}>
//               <InputBoxComponent
//                 displayLabel={true}
//                 controlId="name"
//                 labelText="Name"
//                 inputType="text"
//                 placeHolder="eg. Buy 1 Get 1 Free"
//                 name="name"
//                 onChange={this.onChange}
//                 onFocusOut={this.onFocusOut}
//                 value={this.state.name}
//                 required="required"
//                 showBottom={true}
//                 error={
//                   errors.name === "name is required"
//                     ? "event name is required"
//                     : null
//                 }
//                 inputClassName={classnames("input-component-inputfield", {
//                   invalid: errors.name,
//                 })}
//               />
//               <TextAreaReusableComponent
//                 controlId="descriptionTextArea"
//                 displayText={true}
//                 labelText="Description"
//                 labelSmall="(Fill out the details , offers are used offline)"
//                 labelTextClass="col-12 text-area-lable p-0"
//                 placeholder="eg. A bright Atmosphere"
//                 rows="4"
//                 onChange={this.onChange}
//                 onFocusOut={this.onFocusOut}
//                 name="description"
//                 value={this.state.description}
//                 inputClassName={classnames("input-text-area text-area-new", {
//                   invalid: errors.description,
//                 })}
//                 error={errors.description}
//               />
//               {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 d-flex align-items-center"> */}
//               <div className="row">
//                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center">
//                   <div className="">
//                     <Switch
//                       checked={this.state.eventPrimary}
//                       onChange={this.eventPrimary}
//                       width={40}
//                       height={20}
//                       onColor="#59F832"
//                       onHandleColor="#ffffff"
//                       uncheckedIcon={false}
//                       checkedIcon={false}
//                       boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
//                       activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
//                       // className="react-switch"
//                       id="material-switch"
//                     />
//                   </div>
//                   <div className="pl-2">
//                     <Form.Label className="text-area-lable">
//                       Make This Events Primary
//                     </Form.Label>
//                     <p className="text-area-lable-make-primary">
//                       (Note you can make only one event primary, by making This
//                       event primary it will remove primary from other active
//                       events)
//                     </p>
//                   </div>
//                 </div>
//                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
//                   <InputBoxComponent
//                     displayLabel={true}
//                     showLabelSmall={true}
//                     controlId="couponCode"
//                     labelText={
//                       <div className="d-flex align-items-center">
//                         Coupon Code&nbsp;<p> ( 10 Char )</p>
//                       </div>
//                     }
//                     inputType="text"
//                     placeHolder="eg. c-137"
//                     name="couponCode"
//                     onChange={this.onChange}
//                     onFocusOut={this.onFocusOut}
//                     value={this.state.couponCode}
//                     required="required"
//                     showBottom={true}
//                     error={
//                       errors.couponCode === "couponCode is required"
//                         ? "coupon code is required"
//                         : null
//                     }
//                     inputClassName={classnames("input-component-inputfield", {
//                       invalid: errors.couponCode,
//                     })}
//                   />
//                 </div>
//                 {/* </div> */}
//                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
//                   <InputBoxComponent
//                     displayLabel={true}
//                     controlId="startDate"
//                     labelText="Start Date"
//                     inputType="datetime-local"
//                     placeHolder="Enter Start Date"
//                     name="startDate"
//                     onChange={this.onChange}
//                     onFocusOut={this.onFocusOut}
//                     value={this.state.startDate}
//                     required="required"
//                     showBottom={true}
//                     error={
//                       errors.startDate === "startDate is required"
//                         ? "start date is required"
//                         : null
//                     }
//                     inputClassName={classnames("input-component-inputfield", {
//                       invalid: errors.startDate,
//                     })}
//                   />
//                 </div>
//                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
//                   <InputBoxComponent
//                     displayLabel={true}
//                     controlId="endDate"
//                     labelText="End Date"
//                     inputType="datetime-local"
//                     placeHolder="Enter End Date"
//                     name="endDate"
//                     onChange={this.onChange}
//                     onFocusOut={this.onFocusOut}
//                     value={this.state.endDate}
//                     required="required"
//                     showBottom={true}
//                     error={
//                       errors.endDate === "endDate is required"
//                         ? "end date is required"
//                         : null
//                     }
//                     inputClassName={classnames("input-component-inputfield", {
//                       invalid: errors.endDate,
//                     })}
//                   />
//                 </div>
//               </div>
//               <TextAreaReusableComponent
//                 controlId="address"
//                 displayText={true}
//                 labelText="Venue / Address"
//                 labelTextClass="col-12 text-area-lable p-0"
//                 placeholder="84/36, N Main Rd, Koregaon Park Annexe, Mundhwa, Pune, Maharashtra 411001"
//                 rows="5"
//                 onChange={this.onChange}
//                 onFocusOut={this.onFocusOut}
//                 name="address"
//                 value={this.state.address}
//                 inputClassName={classnames("input-text-area text-area-new", {
//                   invalid: errors.address,
//                 })}
//                 error={errors.address}
//               />
//               <SingleImageReusableComponent
//                 title="Add Photo*"
//                 smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
//                 // onDrop={this.onSingleImageDrop}
//                 onChange={this.onImageLogoUploadHandler}
//                 combined={this.state.combined && this.state.combined}
//                 onCompleteCrop={this.onCompleteCrop}
//                 onCancelCrop={this.onCancelCrop}
//                 file={
//                   (this.state.logo_main &&
//                     this.state.logo_main !== null &&
//                     this.state.logo_main) ||
//                   (this.state.addEvent && this.state.addEvent)
//                 }
//                 resetFile={this.removeFile}
//                 name="addEvent"
//                 error={errors.addEvent}
//               />
//               {/* <div className="file_upload mt-3">
//                 <div className="file-lable-text">
//                   <label>Add Event</label>
//                   <p>
//                     ( You can upload only 1 pic per offer 700 x 420 pixels )
//                   </p>
//                 </div>
//                 <div className="view_chainsBor mt-0" style={{ width: "100%" }}>
//                   <div className="custom_file_upload">
//                     <input
//                       type="file"
//                       name="icon"
//                       id="file"
//                       onChange={this.onImageLogoUploadHandler}
//                       className="custom_input_upload"
//                     />
//                     <label
//                       className="custom_input_label newChain_add"
//                       htmlFor="file"
//                     >
//                       <div>
//                         <i
//                           className="fa fa-plus"
//                           style={{ color: "#CCCCCC" }}
//                         ></i>
//                       </div>
//                       <div className="add_new_text"></div>
//                     </label>
//                   </div>
// >>>>>>> 4433f9782c23e400f1cef29dbefdd83def56e9d7

// //   render() {
// //     const {
// //       open,
// //       errors,
// //       name,
// //       description,
// //       startDate,
// //       endDate,
// //       couponCode,
// //       address,
// //       termsConditions,
// //     } = this.state;
// //     return (
// //       <div>
// //         <IconButtonReusableComponent
// //           buttonText="Add Event"
// //           onClick={this.onOpenModal}
// //           buttonType="button"
// //         />
// //         <Modal
// //           open={open}
// //           onClose={this.onCloseModal}
// //           center
// //           classNames={{
// //             overlay: "customOverlay-request-accept-cancelled",
// //             modal: "offer-event-main",
// //             // closeButton: "customCloseButtonCalling",
// //             animationIn: "customEnterAnimation",
// //             animationOut: "customLeaveAnimation",
// //           }}
// //           animationDuration={1000}
// //         >
// //           <div className="offer-view-topbar">
// //             <h4>{this.props.bigText}</h4>
// //           </div>
// //           <div className="offer-event-popup-peding">
// //             <Form noValidate onSubmit={this.onOfferSubmit}>
// //               <InputBoxComponent
// //                 displayLabel={true}
// //                 controlId="name"
// //                 labelText="Name"
// //                 inputType="text"
// //                 placeHolder="eg. Buy 1 Get 1 Free"
// //                 name="name"
// //                 onChange={this.onChange}
// //                 onFocusOut={this.onFocusOut}
// //                 value={this.state.name}
// //                 required="required"
// //                 showBottom={true}
// //                 error={
// //                   errors.name === "name is required"
// //                     ? "event name is required"
// //                     : null
// //                 }
// //                 inputClassName={classnames("input-component-inputfield", {
// //                   invalid: errors.name,
// //                 })}
// //               />
// //               <TextAreaReusableComponent
// //                 controlId="descriptionTextArea"
// //                 displayText={true}
// //                 labelText="Description"
// //                 labelSmall="(Fill out the details , offers are used offline)"
// //                 labelTextClass="col-12 text-area-lable p-0"
// //                 placeholder="eg. A bright Atmosphere"
// //                 rows="4"
// //                 onChange={this.onChange}
// //                 onFocusOut={this.onFocusOut}
// //                 name="description"
// //                 value={this.state.description}
// //                 inputClassName={classnames("input-text-area text-area-new", {
// //                   invalid: errors.description,
// //                 })}
// //                 error={errors.description}
// //               />
// //               {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 d-flex align-items-center"> */}
// //               <div className="row">
// //                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center">
// //                   <div className="">
// //                     <Switch
// //                       checked={this.state.eventPrimary}
// //                       onChange={this.eventPrimary}
// //                       width={40}
// //                       height={20}
// //                       onColor="#59F832"
// //                       onHandleColor="#ffffff"
// //                       uncheckedIcon={false}
// //                       checkedIcon={false}
// //                       boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
// //                       activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
// //                       // className="react-switch"
// //                       id="material-switch"
// //                     />
// //                   </div>
// //                   <div className="pl-2">
// //                     <Form.Label className="text-area-lable">
// //                       Make This Events Primary
// //                     </Form.Label>
// //                     <p className="text-area-lable-make-primary">
// //                       (Note you can make only one event primary, by making This
// //                       event primary it will remove primary from other active
// //                       events)
// //                     </p>
// //                   </div>
// //                 </div>
// //                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
// //                   <InputBoxComponent
// //                     displayLabel={true}
// //                     showLabelSmall={true}
// //                     controlId="couponCode"
// //                     labelText={
// //                       <div className="d-flex align-items-center">
// //                         Coupon Code&nbsp;<p> ( 10 Char )</p>
// //                       </div>
// //                     }
// //                     inputType="text"
// //                     placeHolder="eg. c-137"
// //                     name="couponCode"
// //                     onChange={this.onChange}
// //                     onFocusOut={this.onFocusOut}
// //                     value={this.state.couponCode}
// //                     required="required"
// //                     showBottom={true}
// //                     error={
// //                       errors.couponCode === "couponCode is required"
// //                         ? "coupon code is required"
// //                         : null
// //                     }
// //                     inputClassName={classnames("input-component-inputfield", {
// //                       invalid: errors.couponCode,
// //                     })}
// //                   />
// //                 </div>
// //                 {/* </div> */}
// //                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
// //                   <InputBoxComponent
// //                     displayLabel={true}
// //                     controlId="startDate"
// //                     labelText="Start Date"
// //                     inputType="datetime-local"
// //                     placeHolder="Enter Start Date"
// //                     name="startDate"
// //                     onChange={this.onChange}
// //                     onFocusOut={this.onFocusOut}
// //                     value={this.state.startDate}
// //                     required="required"
// //                     showBottom={true}
// //                     error={
// //                       errors.startDate === "startDate is required"
// //                         ? "start date is required"
// //                         : null
// //                     }
// //                     inputClassName={classnames("input-component-inputfield", {
// //                       invalid: errors.startDate,
// //                     })}
// //                   />
// //                 </div>
// //                 <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
// //                   <InputBoxComponent
// //                     displayLabel={true}
// //                     controlId="endDate"
// //                     labelText="End Date"
// //                     inputType="datetime-local"
// //                     placeHolder="Enter End Date"
// //                     name="endDate"
// //                     onChange={this.onChange}
// //                     onFocusOut={this.onFocusOut}
// //                     value={this.state.endDate}
// //                     required="required"
// //                     showBottom={true}
// //                     error={
// //                       errors.endDate === "endDate is required"
// //                         ? "end date is required"
// //                         : null
// //                     }
// //                     inputClassName={classnames("input-component-inputfield", {
// //                       invalid: errors.endDate,
// //                     })}
// //                   />
// //                 </div>
// //               </div>
// //               <TextAreaReusableComponent
// //                 controlId="address"
// //                 displayText={true}
// //                 labelText="Venue / Address"
// //                 labelTextClass="col-12 text-area-lable p-0"
// //                 placeholder="84/36, N Main Rd, Koregaon Park Annexe, Mundhwa, Pune, Maharashtra 411001"
// //                 rows="5"
// //                 onChange={this.onChange}
// //                 onFocusOut={this.onFocusOut}
// //                 name="address"
// //                 value={this.state.address}
// //                 inputClassName={classnames("input-text-area text-area-new", {
// //                   invalid: errors.address,
// //                 })}
// //                 error={errors.address}
// //               />
// //               <SingleImageReusableComponent
// //                 title="Add Photo*"
// //                 smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
// //                 // onDrop={this.onSingleImageDrop}
// //                 onChange={this.onImageLogoUploadHandler}
// //                 file={this.state.addEvent}
// //                 resetFile={this.removeFile}
// //                 name="addEvent"
// //                 error={errors.addEvent}
// //               />
// //               {/* <div className="file_upload mt-3">
// //                 <div className="file-lable-text">
// //                   <label>Add Event</label>
// //                   <p>
// //                     ( You can upload only 1 pic per offer 700 x 420 pixels )
// //                   </p>
// //                 </div>
// //                 <div className="view_chainsBor mt-0" style={{ width: "100%" }}>
// //                   <div className="custom_file_upload">
// //                     <input
// //                       type="file"
// //                       name="icon"
// //                       id="file"
// //                       onChange={this.onImageLogoUploadHandler}
// //                       className="custom_input_upload"
// //                     />
// //                     <label
// //                       className="custom_input_label newChain_add"
// //                       htmlFor="file"
// //                     >
// //                       <div>
// //                         <i
// //                           className="fa fa-plus"
// //                           style={{ color: "#CCCCCC" }}
// //                         ></i>
// //                       </div>
// //                       <div className="add_new_text"></div>
// //                     </label>
// //                   </div>

// //                   <div className="newChain_addthree mx-3">
// //                     {this.state.addEvent ? (
// //                       <img
// //                         src={this.state.addEvent}
// //                         className="newChain_addtwo"
// //                         style={{ height: "100%", width: "100%" }}
// //                         alt="chain"
// //                       />
// //                     ) : null}
// //                   </div>
// //                 </div>
// //                 <Form.Text className="text-muted input-component-bottom">
// //                   <div className="text-danger text-capitalize">
// //                     {errors.addOffer}
// //                   </div>
// //                 </Form.Text>
// //               </div> */}
// //               <div className="offer-event-mobile-floatingtext">
// //                 <TextAreaReusableComponent
// //                   controlId="termsConditions"
// //                   displayText={true}
// //                   labelText="Terms & Conditions"
// //                   labelSmall="(Fill out the terms and conditions for offers are used offline)"
// //                   labelTextClass="col-12 text-area-lable p-0"
// //                   placeholder="eg. Offers are valid during week days and cannot be combined with any other offer Payment offers are some times offered in combination with other payment partners"
// //                   rows="4"
// //                   onChange={this.onChange}
// //                   onFocusOut={this.onFocusOut}
// //                   name="termsConditions"
// //                   value={this.state.termsConditions}
// //                   inputClassName={classnames("input-text-area text-area-new", {
// //                     invalid: errors.termsConditions,
// //                   })}
// //                   error={
// //                     errors.termsConditions === "termsConditions is required"
// //                       ? "terms conditions is required"
// //                       : null
// //                   }
// //                 />
// //               </div>
// //               <div className="offer-event-mobile-button-float">
// //                 <div className="bottom-button d-flex justify-content-between mt-3 offer-event-inside-button">
// //                   <PopupActionButton
// //                     buttonText="Cancel"
// //                     buttonType="button"
// //                     buttonClass="bigbuttonred"
// //                     onClick={this.onCloseModal}
// //                   />
// //                   <div className="offer-event-inside-button-margin">
// //                     <PopupActionButton
// //                       buttonText="Save"
// //                       buttonType={
// //                         name === "" ||
// //                         description === "" ||
// //                         startDate === "" ||
// //                         endDate === "" ||
// //                         couponCode === "" ||
// //                         address === "" ||
// //                         termsConditions === ""
// //                           ? "button"
// //                           : "Submit"
// //                       }
// //                       buttonClass={
// //                         name === "" ||
// //                         description === "" ||
// //                         startDate === "" ||
// //                         endDate === "" ||
// //                         couponCode === "" ||
// //                         address === "" ||
// //                         termsConditions === ""
// //                           ? "bigbuttongray"
// //                           : "bigbuttongreen"
// //                       }
// //                       disabled={
// //                         name === "" ||
// //                         description === "" ||
// //                         startDate === "" ||
// //                         endDate === "" ||
// //                         couponCode === "" ||
// //                         address === "" ||
// //                         termsConditions === ""
// //                           ? true
// //                           : false
// //                       }
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </Form>
// //           </div>
// //         </Modal>
// //       </div>
// //     );
// //   }
// // }

// // EventPopup.propTypes = {
// //   auth: PropTypes.object.isRequired,
// //   errors: PropTypes.object.isRequired,
// //   onboarding: PropTypes.object.isRequired,
// // };

// // const mapStateToProps = (state) => ({
// //   auth: state.auth,
// //   errors: state.errors.errors,
// //   onboarding: state.onboarding.restaurantDetails,
// // });

// // export default connect(mapStateToProps, {
// //   clear_all_errors,
// //   vendor_create_new_events,
// // })(withRouter(EventPopup));
